import {useState, useEffect} from "react";
import ConsignmentNearByTrucks from '../manage/consignment-nearby-trucks'
import FOLocations from "./folocations.jsx";
const LocationsMap = ()=>{
    const tabs = [{label:"vehicle_locations", value: "Vehicle Locations"}, {label:"fo_locations", value: "FO Locations"}]
    const [tab, setTab] = useState("vehicle_locations")

    return(
        <div>
            <h6 className="ml-3">Vehicle/FO Locations</h6>
            <div className="ml-3 mb-3">
  {tabs.map(e => (
    <button
      key={e.value}
      onClick={() => setTab(e.label)}
      className={tab === e.label ? "btn btn-info f14" : "btn tab-btn f14"}
    >
      {e.value}
    </button>
  ))}
</div>
            {tab==="vehicle_locations" && <ConsignmentNearByTrucks />}
            {tab==="fo_locations" && <FOLocations />}
            </div>

    )
}

export default LocationsMap